import { cn } from "@/domains/library"

export const ScaleInnerCard200 = ({
  children,
  className,
  onClick,
  style,
  enabled = false,
}: {
  children: React.ReactNode
  className?: string
  enabled?: boolean
  style?: React.CSSProperties
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void
}) => {
  const handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
    if (onClick) {
      onClick(event)
    }
  }
  const s: React.CSSProperties = {
    opacity: 0.7,
    ...style,
  }
  if (enabled === true) {
    s.opacity = 1
  }

  return (
    <div
      className={cn(
        "sc-inner-card-200",
        "rounded-lg",
        "transition-all duration-300 ease-in-out",
        "border",
        enabled ? "bg-p200 hover:bg-p200-light" : "bg-p200-shade hover:bg-p200",
        enabled ? "border-p200-shade" : "border-p100-shade",
        className,
      )}
      data-enabled={enabled ? "true" : "false"}
      style={s}
      onClick={handleClick}
    >
      {children}
    </div>
  )
}
